import React from 'react';

import FormInvalid from './FormInvalid';

function FormFileGroup({ field, value, label, error, handleChange, classes = '', acceptExtensions = "*" }) {
    function hasError() {
        return !!error;
    }

    function renderError() {
        if (hasError()) {
            return <FormInvalid message={error} />;
        }
    }

    return (
        <div className="form-group">
            <label htmlFor={field}>{label}</label>
            {value && <img src={value} className={`w-50 ${classes}`} alt={field} />}
            <input
                type="file"
                id={field}
                className={`form-control ${hasError() ? 'is-invalid' : ''}`}
                name={field}
                onChange={handleChange}
                accept={acceptExtensions}
            />
            {renderError()}
        </div>
    );
}

export default FormFileGroup;
